import React, { useEffect } from 'react';
import Icon from 'chameleon/ui-stack/ui/base/icon';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';
import { sendToTelemetry, TLTRY_DEFAULTS } from 'legacy-src/utility/telemetry';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import './PageNotFound.scss';

const PageNotFound = ({ userData, router }) => {
  const { me, studentSubjects, teacherSubjects, adminSubjects } =
    userData || {};
  const { location } = router || {};
  const { pathname, search } = location || {};

  useEffect(() => {
    sendToTelemetry({
      event_type: '404_page_triggered',
      current_url: `${pathname || ''}${search || ''}`,
      previous_url: window.sessionStorage.getItem('apc:locationFrom') || '',
      user_agent: window.navigator.userAgent,
      ...TLTRY_DEFAULTS[0],
    });
  }, []);

  let userSubjects = teacherSubjects;

  if (me?.isStudent) {
    userSubjects = studentSubjects;
  } else if (me?.isAdmin) {
    userSubjects = adminSubjects;
  }

  const buttonOnClick = (event) => {
    event.preventDefault();
    /**
     * window.location is used because we have routes, e.g. when the wrong
     * url is actually opening the student assignment player, where using
     * router.push does not work at all. The URL changes, but the linked
     * page is not opened. window.location is the tradeoff.
     */
    if (userSubjects?.length > 1) {
      window.location.href = '/subjects/preview';
    }

    if (userSubjects?.length === 1) {
      window.location.href = `/${userSubjects[0].id}/home`;
    }
  };

  return (
    <div className="page_wrapper">
      <div className="page_not_found m-auto flex">
        <div className="float-left">
          <Icon
            id="close"
            width="26.43"
            height="26.43"
            className="close-icon text-white mr-8 mt-1"
            role="presentation"
            accessibility={{ ariaHidden: true }}
          />
        </div>
        <div className="float-right">
          <div className="font-medium">Sorry</div>
          <p>
            The page you requested cannot be found. You may have typed the{' '}
            address incorrectly or used an outdated link. Please try again, or{' '}
            go to your AP Classroom homepage.
          </p>
          <ButtonWithIcon
            isLink
            isNaked
            tabIndex="-1"
            iconOrientation="right"
            accessibility={{ ariaLabel: 'AP Classroom Link' }}
            icon="chevron_right"
            className="font-medium"
            onClick={buttonOnClick}
          >
            AP Classroom Homepage
          </ButtonWithIcon>
        </div>
      </div>
    </div>
  );
};

PageNotFound.displayName = 'PageNotFound';

let mapStateToProps = (state) => ({
  userData: state.userData,
});

export default connect(mapStateToProps)(withRouter(PageNotFound));
